<template>
  <div>
    <v-expansion-panels v-model="panel" class="mt-2">
      <v-expansion-panel>
        <v-expansion-panel-header> New Products </v-expansion-panel-header>
        <v-expansion-panel-content>
          <AddUrl class="my-3" @close_validation="panel=undefined" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div v-if="conflict_ids.length > 0">
      <div v-for="(product_id,conflict_idx) in conflict_ids" :key="product_id">
        <ConflictCard
          :current_conflict_product_id="parseInt(product_id)"
          :conflict_index="conflict_idx"
          :for_create_new_product="true"
        />
      </div>
      <span
        v-if="!!new_valids_urls.length"
        class="title ms-10 mt-2 yellow--text text--darken-4"
      >
        You can remove these conflicts and create the product without these urls.
      </span>
    </div>

    <!-- <div
      v-for="(new_url, n_index) in new_valids_urls"
      :key="n_index"
      class="my-2"
    >
      <ProductCreation :url="new_url" />
    </div> -->
    <ProductCreation
      v-if="!!new_valids_urls.length && !conflict_ids.length"
      :urls="new_valids_urls"
      class="mt-2"
      @created_new_product="$emit('reloadProduct')"
    />

    <!-- <div class="mb-15"></div> -->

  </div>
</template>

<script>
/* eslint-disable */
import AddUrl from "./N_Add_Url.vue";
import ConflictCard from "./N_ConflictCard.vue";
import ValidsTable from "./N_ValidsTable.vue";
import ProductCreation from "./N_ProductCreation.vue";

export default {
  name: "n-new-product",
  components: {
    AddUrl,
    ConflictCard,
    ValidsTable,
    ProductCreation,
  },
  data() {
    return {
      panel: 0,
    };
  },
  computed: {
    conflict_ids() {
      return this.$store.state.productionModule.products_ids_with_conflict;
    },
    new_valids_urls() {
      return this.$store.getters["productionModule/new_valids_domains_urls"];
    },
  },
  methods: {
    initialize() {
      const data = {value: 0, key: 'id'};
      this.$store.commit('productionModule/SET_SELECTED_PRODUCT', data);
      this.$store.commit('productionModule/RESET_SPECS_OF_SELECTED_ITEM');
    },
  },
  mounted() {
    this.initialize();
  },

};
</script>



// WEBPACK FOOTER //
// src/components/production/N_NewProduct.vue